import React from 'react'
import { useTranslation } from 'react-i18next'
import Checkbox from '../../../../common/inputs/checkbox/Checkbox'
import { SCREEN_OBJECT_DETAILS, SCREENS } from '../../../../../services/domain/wizardScreens'
import { ObjectDetailsWrapperProps } from './ObjectDetails'

const screen = SCREENS[SCREEN_OBJECT_DETAILS]

export const RequiredWBSField: React.FC<ObjectDetailsWrapperProps> = ({ insertionData, onChange }) => {
  const { t } = useTranslation()

  return (
    <div className='grid-item one-whole margin-top-s'>
      <Checkbox
        id='wbs-required'
        onChange={(_name, checked) =>
          onChange({ screen: screen.name, property: 'estateFeatures.certificateOfEligibilityNeeded' }, checked)
        }
        name='wbsRequired'
        checked={insertionData.estateFeatures?.certificateOfEligibilityNeeded ?? false}
        label={<span>{t('wizard.screen.objectDetails.wbsRequired')}</span>}
      />
    </div>
  )
}
